module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/106.9ffd17ea.png";